import type { InternalAuditReportByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetInternalAuditReportByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetInternalAuditReportByIdArgs = {
  reportId: string;
};

export const useLazyGetInternalAuditReportById = createLazyQueryHook<
  UseLazyGetInternalAuditReportByIdArgs,
  InternalAuditReportByIdResponseRow[],
  GetInternalAuditReportByIdQuery
>({
  trpcQuery: (client, { reportId }) =>
    client.frontend.internalAuditReport.internalAuditReportById.query({
      reportId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ internal_audit_report: data }),
  graphqlDocument: GetInternalAuditReportByIdDocument,
  graphqlVariables: ({ reportId }) => ({ Id: reportId }),
});
